import { render, staticRenderFns } from "./AddPhoto.vue?vue&type=template&id=5da151b8&"
import script from "./AddPhoto.vue?vue&type=script&lang=js&"
export * from "./AddPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports